import { Grid, GridItem } from "@caspeco/casper-ui-library.components.grid";
import { useMinWidthMediaQuery } from "hooks/useMediaQuery";
import { UpsellArticle } from "types/article";
import { BreakPoint } from "types/ui";
import { StyledGridWrapper } from "./UpsellGrid.styles";

interface IUpsellGrid {
	items: UpsellArticle[];
	renderGridItem: (item: UpsellArticle) => JSX.Element;
}

export function UpsellGrid({ items, renderGridItem }: IUpsellGrid) {
	const isLargerThanLargeBreakPoint = useMinWidthMediaQuery(BreakPoint.Large);
	const isLargerThanXLargeBreakPoint = useMinWidthMediaQuery(BreakPoint.XLarge);

	let columnCount = 2;
	if (isLargerThanLargeBreakPoint) columnCount = 3;
	if (isLargerThanXLargeBreakPoint) columnCount = 4;

	return (
		<StyledGridWrapper $columncount={columnCount}>
			<Grid
				className="grid-with-dividers"
				columnGap="32px"
				rowGap="32px"
				templateColumns={`repeat(${columnCount}, 1fr)`}
				gridAutoRows="1fr"
			>
				{items.map((item: UpsellArticle) => (
					<GridItem
						key={item.id}
						display="flex"
						justifyContent="space-between"
						flexDirection="column"
						className="grid-with-dividers-griditem"
					>
						{renderGridItem(item)}
					</GridItem>
				))}
			</Grid>
		</StyledGridWrapper>
	);
}
